export const TAB_PLAYER_VIEW_ID_KEY = 'absorPlayerViewId';

const VALID_VIEW_ID = /^fe_[A-Za-z0-9_-]{8,80}$/;
let memoryFallbackViewId = null;

export function createFrontendViewId() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      const entropy = new Uint32Array(3);
      crypto.getRandomValues(entropy);
      return `fe_${Array.from(entropy, (value) => value.toString(36).padStart(7, '0')).join('')}`;
    }
  } catch (_) {
    // Fall through to the non-cryptographic correlation-only id.
  }
  return `fe_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14).padEnd(12, '0')}`;
}

function browserSessionStorage() {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch (_) {
    return null;
  }
}

/**
 * One id per browser tab, stable across channel changes and reloads. Separate
 * tabs have separate sessionStorage areas, while private/blocked storage falls
 * back to one in-memory id for the lifetime of the page.
 */
export function getOrCreateTabPlayerViewId(
  storage = browserSessionStorage(),
  createId = createFrontendViewId
) {
  if (storage) {
    try {
      const existing = storage.getItem(TAB_PLAYER_VIEW_ID_KEY);
      if (VALID_VIEW_ID.test(existing || '')) return existing;
      const created = createId();
      storage.setItem(TAB_PLAYER_VIEW_ID_KEY, created);
      return created;
    } catch (_) {
      // Use the stable in-memory fallback below.
    }
  }

  if (!memoryFallbackViewId) memoryFallbackViewId = createId();
  return memoryFallbackViewId;
}
